// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SensorRouteImport } from './routes/sensor'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EventsIndexRouteImport } from './routes/events/index'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminImagesRouteImport } from './routes/admin/images'
import { Route as AdminHardwareTestRouteImport } from './routes/admin/hardware-test'
import { Route as EventsEventIdIndexRouteImport } from './routes/events/$eventId/index'
import { Route as EventsEventIdTvRouteImport } from './routes/events/$eventId/tv'
import { Route as EventsEventIdStagingRouteImport } from './routes/events/$eventId/staging'
import { Route as EventsEventIdSlideshowRouteImport } from './routes/events/$eventId/slideshow'
import { Route as EventsEventIdRegisterRouteImport } from './routes/events/$eventId/register'
import { Route as EventsEventIdQrRouteImport } from './routes/events/$eventId/qr'
import { Route as AdminEventsIndexRouteImport } from './routes/admin/events/index'
import { Route as AdminEventsNewRouteImport } from './routes/admin/events/new'
import { Route as EventsEventIdVoteBallotIdRouteImport } from './routes/events/$eventId/vote.$ballotId'
import { Route as EventsEventIdCarsCarIdRouteImport } from './routes/events/$eventId/cars.$carId'
import { Route as AdminEventsEventIdIndexRouteImport } from './routes/admin/events/$eventId/index'
import { Route as AdminEventsEventIdVotingRouteImport } from './routes/admin/events/$eventId/voting'
import { Route as AdminEventsEventIdTvControlRouteImport } from './routes/admin/events/$eventId/tv-control'
import { Route as AdminEventsEventIdScheduleRouteImport } from './routes/admin/events/$eventId/schedule'
import { Route as AdminEventsEventIdRaceRouteImport } from './routes/admin/events/$eventId/race'
import { Route as AdminEventsEventIdCheckinRouteImport } from './routes/admin/events/$eventId/checkin'
import { Route as AdminEventsEventIdCarsRouteImport } from './routes/admin/events/$eventId/cars'
import { Route as AdminEventsEventIdAwardsRouteImport } from './routes/admin/events/$eventId/awards'
import { Route as AdminEventsEventIdAuditRouteImport } from './routes/admin/events/$eventId/audit'

const SensorRoute = SensorRouteImport.update({
            id: '/sensor',path: '/sensor',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const AdminRouteRoute = AdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const EventsIndexRoute = EventsIndexRouteImport.update({
            id: '/events/',path: '/events/',getParentRoute: () => rootRouteImport
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRouteRoute
          })
const AdminImagesRoute = AdminImagesRouteImport.update({
            id: '/images',path: '/images',getParentRoute: () => AdminRouteRoute
          })
const AdminHardwareTestRoute = AdminHardwareTestRouteImport.update({
            id: '/hardware-test',path: '/hardware-test',getParentRoute: () => AdminRouteRoute
          })
const EventsEventIdIndexRoute = EventsEventIdIndexRouteImport.update({
            id: '/events/$eventId/',path: '/events/$eventId/',getParentRoute: () => rootRouteImport
          })
const EventsEventIdTvRoute = EventsEventIdTvRouteImport.update({
            id: '/events/$eventId/tv',path: '/events/$eventId/tv',getParentRoute: () => rootRouteImport
          })
const EventsEventIdStagingRoute = EventsEventIdStagingRouteImport.update({
            id: '/events/$eventId/staging',path: '/events/$eventId/staging',getParentRoute: () => rootRouteImport
          })
const EventsEventIdSlideshowRoute = EventsEventIdSlideshowRouteImport.update({
            id: '/events/$eventId/slideshow',path: '/events/$eventId/slideshow',getParentRoute: () => rootRouteImport
          })
const EventsEventIdRegisterRoute = EventsEventIdRegisterRouteImport.update({
            id: '/events/$eventId/register',path: '/events/$eventId/register',getParentRoute: () => rootRouteImport
          })
const EventsEventIdQrRoute = EventsEventIdQrRouteImport.update({
            id: '/events/$eventId/qr',path: '/events/$eventId/qr',getParentRoute: () => rootRouteImport
          })
const AdminEventsIndexRoute = AdminEventsIndexRouteImport.update({
            id: '/events/',path: '/events/',getParentRoute: () => AdminRouteRoute
          })
const AdminEventsNewRoute = AdminEventsNewRouteImport.update({
            id: '/events/new',path: '/events/new',getParentRoute: () => AdminRouteRoute
          })
const EventsEventIdVoteBallotIdRoute = EventsEventIdVoteBallotIdRouteImport.update({
            id: '/events/$eventId/vote/$ballotId',path: '/events/$eventId/vote/$ballotId',getParentRoute: () => rootRouteImport
          })
const EventsEventIdCarsCarIdRoute = EventsEventIdCarsCarIdRouteImport.update({
            id: '/events/$eventId/cars/$carId',path: '/events/$eventId/cars/$carId',getParentRoute: () => rootRouteImport
          })
const AdminEventsEventIdIndexRoute = AdminEventsEventIdIndexRouteImport.update({
            id: '/events/$eventId/',path: '/events/$eventId/',getParentRoute: () => AdminRouteRoute
          })
const AdminEventsEventIdVotingRoute = AdminEventsEventIdVotingRouteImport.update({
            id: '/events/$eventId/voting',path: '/events/$eventId/voting',getParentRoute: () => AdminRouteRoute
          })
const AdminEventsEventIdTvControlRoute = AdminEventsEventIdTvControlRouteImport.update({
            id: '/events/$eventId/tv-control',path: '/events/$eventId/tv-control',getParentRoute: () => AdminRouteRoute
          })
const AdminEventsEventIdScheduleRoute = AdminEventsEventIdScheduleRouteImport.update({
            id: '/events/$eventId/schedule',path: '/events/$eventId/schedule',getParentRoute: () => AdminRouteRoute
          })
const AdminEventsEventIdRaceRoute = AdminEventsEventIdRaceRouteImport.update({
            id: '/events/$eventId/race',path: '/events/$eventId/race',getParentRoute: () => AdminRouteRoute
          })
const AdminEventsEventIdCheckinRoute = AdminEventsEventIdCheckinRouteImport.update({
            id: '/events/$eventId/checkin',path: '/events/$eventId/checkin',getParentRoute: () => AdminRouteRoute
          })
const AdminEventsEventIdCarsRoute = AdminEventsEventIdCarsRouteImport.update({
            id: '/events/$eventId/cars',path: '/events/$eventId/cars',getParentRoute: () => AdminRouteRoute
          })
const AdminEventsEventIdAwardsRoute = AdminEventsEventIdAwardsRouteImport.update({
            id: '/events/$eventId/awards',path: '/events/$eventId/awards',getParentRoute: () => AdminRouteRoute
          })
const AdminEventsEventIdAuditRoute = AdminEventsEventIdAuditRouteImport.update({
            id: '/events/$eventId/audit',path: '/events/$eventId/audit',getParentRoute: () => AdminRouteRoute
          })





const AdminRouteRouteChildren = {
  AdminHardwareTestRoute: AdminHardwareTestRoute,AdminImagesRoute: AdminImagesRoute,AdminUsersRoute: AdminUsersRoute,AdminEventsNewRoute: AdminEventsNewRoute,AdminEventsIndexRoute: AdminEventsIndexRoute,AdminEventsEventIdAuditRoute: AdminEventsEventIdAuditRoute,AdminEventsEventIdAwardsRoute: AdminEventsEventIdAwardsRoute,AdminEventsEventIdCarsRoute: AdminEventsEventIdCarsRoute,AdminEventsEventIdCheckinRoute: AdminEventsEventIdCheckinRoute,AdminEventsEventIdRaceRoute: AdminEventsEventIdRaceRoute,AdminEventsEventIdScheduleRoute: AdminEventsEventIdScheduleRoute,AdminEventsEventIdTvControlRoute: AdminEventsEventIdTvControlRoute,AdminEventsEventIdVotingRoute: AdminEventsEventIdVotingRoute,AdminEventsEventIdIndexRoute: AdminEventsEventIdIndexRoute
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(AdminRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRouteRoute: AdminRouteRouteWithChildren,DashboardRoute: DashboardRoute,LoginRoute: LoginRoute,SensorRoute: SensorRoute,EventsIndexRoute: EventsIndexRoute,EventsEventIdQrRoute: EventsEventIdQrRoute,EventsEventIdRegisterRoute: EventsEventIdRegisterRoute,EventsEventIdSlideshowRoute: EventsEventIdSlideshowRoute,EventsEventIdStagingRoute: EventsEventIdStagingRoute,EventsEventIdTvRoute: EventsEventIdTvRoute,EventsEventIdIndexRoute: EventsEventIdIndexRoute,EventsEventIdCarsCarIdRoute: EventsEventIdCarsCarIdRoute,EventsEventIdVoteBallotIdRoute: EventsEventIdVoteBallotIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)